/**
 * Application Configuration
 *
 * Environment Variables:
 * - REACT_APP_API_URL: Backend API URL (set in .env files)
 *
 * For local development: http://127.0.0.1:8000
 * For Render production: https://adress-api.onrender.com
 */

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

// You can add other config values here as needed
export const config = {
  apiUrl: API_BASE_URL,
};

export default config;
